import { render } from "./UserSelect.vue?vue&type=template&id=7055c07a&ts=true"
import script from "./UserSelect.vue?vue&type=script&lang=ts"
export * from "./UserSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__